<template>
  <div class="about">
    <v-content>
      <v-container fluid>
        <p>This is an About Page</p>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: "about"
};
</script>
